module.exports = __webpack_public_path__ + "static/media/yoga.e3a6b127.svg";